import { FC } from 'react';
import { Button, Stack, Typography } from '@mui/material';
import { CenteredCardView } from '@vs-online-only-app/ui';
import { CheckCircleOutline } from '@mui/icons-material';

type Props = {
  startStepper: () => void;
};

const IntroModulesLandingPage: FC<Props> = ({ startStepper }) => (
  <CenteredCardView
    body={
      <Stack gap={4}>
        {/* TODO: Add lottie animation here */}
        <Typography variant="h4">How the Store App works</Typography>
        <Typography variant="body1">
          Let's take a few minutes to get you up to speed.
        </Typography>
        <Stack gap={2}>
          <Stack
            direction="row"
            justifyContent="space-between"
            style={{ opacity: 0.5 }}
          >
            <Typography fontWeight="bold">1. Set up your profile</Typography>
            <CheckCircleOutline />
          </Stack>
          <Stack direction="row" gap={1}>
            <Typography fontWeight="bold">2. See how it works</Typography>
          </Stack>
        </Stack>
        <Button size="large" onClick={startStepper} variant="contained">
          Get started
        </Button>
      </Stack>
    }
  />
);

export default IntroModulesLandingPage;
